// extracted by mini-css-extract-plugin
export default {"orInput":"Input_input__QMmaj","input":"Textarea_input__a4ohK Input_input__QMmaj"};